import React, { useContext, useEffect, useState } from "react";
import "./EditTeam.Styles.scss";
import EditTeamSheetComponent from "./../../components/elements/EditTeamSheet.Component";
import { DateInput, IDateFormatProps } from "@blueprintjs/datetime";
import Inputbox from "../../components/elements/Inputbox.Element";
import { Formation } from "../../interfaces/Formation.Interface";
import { firebaseContext } from "../../contexts/FirebaseContext";
import { DB_REF } from "../../constants/DB";
import { dateToFirestore } from "../../services/DateToFirestore";
import { Button } from "@blueprintjs/core";

export default function EditTeamComponent() {
  const firebase = useContext(firebaseContext);
  const [haveSavedFormation, setHaveSavedFormation] = useState(false);
  const [formation, setFormation] = useState<Formation>({
    foward: 3,
    midfield: 3,
    defend: 4,
  });
  const [formation2, setFormation2] = useState<Formation>({
    foward: 3,
    midfield: 3,
    defend: 4,
  });

  const [date, setDate] = useState(new Date());

  const onChange = async (date: Date) => {
    setDate(date);
  };

  const jsDateFormatter: IDateFormatProps = {
    // note that the native implementation of Date functions differs between browsers
    formatDate: (date) => date.toLocaleDateString(),
    parseDate: (str) => new Date(str),
    placeholder: "M/D/YYYY",
  };

  const changeFormation = (key: string, num: string) => {
    const val = {
      ...formation,
      [key]: parseInt(num) || 0,
    };
    setFormation(val);
  };

  const changeFormation2 = (key: string, num: string) => {
    const val = {
      ...formation2,
      [key]: parseInt(num) || 0,
    };
    setFormation2(val);
  };

  useEffect(() => {
    firebase
      .firestore()
      .collection(DB_REF.teamCards)
      .doc(dateToFirestore(date))
      .onSnapshot((doc) => {
        if (doc.exists) {
          setHaveSavedFormation(true);
          setFormation(doc.data()!.formation);
          setFormation2(doc.data()!.formation2);
        } else {
          setHaveSavedFormation(false);
        }
      });
  }, [date, firebase]);

  const deleteFormation = async () => {
    const doc = firebase
      .firestore()
      .collection(DB_REF.teamCards)
      .doc(dateToFirestore(date));

    doc.delete();
  };

  return (
    <div className="edit-team-container">
      <div
        style={{
          alignItems: "center",
          display: "flex",
          paddingTop: 40,
          flexDirection: "column",
        }}
      >
        <div style={{ padding: 10 }}>Create a New Team Sheet</div>
        <div style={{ padding: 10 }}>
          <DateInput {...jsDateFormatter} value={date} onChange={onChange} />
        </div>
        <p>Team 01 </p>
        <div style={{ display: "flex" }}>
          <Inputbox
            label="Defenders"
            helperText="# of defenders"
            id="defend"
            value={formation.defend.toString()}
            onChange={(val) => changeFormation("defend", val)}
          />
          <Inputbox
            value={formation.midfield.toString()}
            label="Midfielders"
            id="midfield"
            helperText="# of midfielders"
            onChange={(val) => changeFormation("midfield", val)}
          />
          <Inputbox
            label="Fowards"
            onChange={(val) => changeFormation("foward", val)}
            helperText="# of fowards"
            id="foward"
            value={formation.foward.toString()}
          />
        </div>
        <p>Team 02</p>
        <div style={{ display: "flex" }}>
          <Inputbox
            label="Defenders"
            helperText="# of defenders"
            id="defend"
            value={formation2.defend.toString()}
            onChange={(val) => changeFormation2("defend", val)}
          />
          <Inputbox
            value={formation2.midfield.toString()}
            label="Midfielders"
            id="midfield"
            helperText="# of midfielders"
            onChange={(val) => changeFormation2("midfield", val)}
          />
          <Inputbox
            label="Fowards"
            onChange={(val) => changeFormation2("foward", val)}
            helperText="# of fowards"
            id="foward"
            value={formation2.foward.toString()}
          />
        </div>
        <div
          style={{
            padding: 20,
            display: "flex",
            justifyContent: "center",
          }}
        >
          {haveSavedFormation && (
            <Button
              onClick={deleteFormation}
              intent="danger"
              text="Delete Formation"
            />
          )}
        </div>
      </div>
      <div>
        <EditTeamSheetComponent
          date={date}
          formation={formation}
          formation2={formation2}
        />
      </div>
    </div>
  );
}
